<section class="hero-section">
    <!-- Background Image with Overlay -->
    <div class="hero-bg">
        <img src="../../../assets/hero-blocks.jpg" alt="Colorful toy blocks" />
        <div class="hero-overlay hero-gradient"></div>
    </div>

    <!-- Content -->
    <div class="hero-container generic-container">
        <div class="hero-content animate-fade-in">
            <h1 class="animate-slide-up">
                Build Your
                <span class="highlight highlight-gradient-text2 animate-bounce-in">Imagination</span>
            </h1>

            <p class="animate-fade-in">
                Discover endless possibilities with our premium toy blocks. Create, learn, and play with designs that
                spark creativity and bring joy to every moment.
            </p>

            <div class="hero-buttons animate-slide-up">
                <a [routerLink]="['/products']" routerLinkActive="router-link-active">
                    <app-button variant="hero" size="xl" class="group" buttonClass="glow">
                        Shop Now
                        <mat-icon buttonClass="arrow-icon" class="group-hover:translate-x-1">arrow_forward</mat-icon>
                    </app-button>
                </a>

                <a [routerLink]="['/designer']" routerLinkActive="router-link-active">
                    <app-button variant="outline" size="xl" buttonClass="startDesignBtn">
                        <mat-icon class="play-icon">play_arrow</mat-icon>
                        Start Designing
                    </app-button>
                </a>
            </div>
        </div>

        <!-- Floating Shapes -->
        <div class="shape shape-orange animate-float hidden lg:block"></div>
        <div class="shape shape-green animate-float hidden lg:block" [ngStyle]="{ animationDelay: '1s' }"></div>
        <div class="shape shape-blue animate-float hidden lg:block" [ngStyle]="{ animationDelay: '2s' }"></div>
    </div>

    <!-- Scroll Indicator -->
    <div class="scroll-indicator animate-bounce">
        <div class="scroll-box">
            <div class="scroll-dot animate-pulse"></div>
        </div>
    </div>
</section>
